import { createWorkspaceServiceClient } from '@nimbus/workspace-service';
import { generalEnv } from '@nx-frontend/shared/env';

export async function getOrgRoles(userId: number): Promise<Record<string, string>> {
  const orgServiceClient = createWorkspaceServiceClient({
    basePath: generalEnv.orgServiceUrl + '/v1',
    secret: generalEnv.secret,
    superSecret: generalEnv.superSecret,
  });
  const response = await orgServiceClient.AccessApi.apiGetRoles({}, { userId });
  return response.data;
}
